module.exports = __webpack_public_path__ + "static/media/2@960w.7740e1c2.jpg";